module.exports = __webpack_public_path__ + "static/ig_banner_09-89d7b9d78e77188bbc46c82fe5988678.png";